/**
 * Publishes the cookie banner's height as --cs-consent-h so the page can make
 * room for it.
 *
 * Shopify renders #shopify-pc__banner position:fixed, so it sits ON TOP of the
 * page — the footer, the chat launcher and anything else at the bottom end up
 * underneath it. Nothing in CSS can know how tall it is (the notice wraps to a
 * different number of lines at every width), so it is measured here.
 *
 * The banner is injected after load and removed on dismiss, so this watches
 * both: a ResizeObserver for height changes, and a MutationObserver on body for
 * it appearing or going away. When it goes, the variable returns to 0 and the
 * space collapses.
 */
(function () {
  const root = document.documentElement;
  const set = (px) => root.style.setProperty('--cs-consent-h', px + 'px');
  set(0);

  let ro = null;

  const measure = (el) => {
    if (!el || !el.isConnected) return set(0);
    const h = Math.round(el.getBoundingClientRect().height);
    set(getComputedStyle(el).display === 'none' ? 0 : h);
  };

  const attach = () => {
    const el = document.querySelector('#shopify-pc__banner');
    if (ro) ro.disconnect();
    if (!el) return set(0);
    measure(el);
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(() => measure(el));
      ro.observe(el);
    }
  };

  attach();
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: false });
  window.addEventListener('resize', attach, { passive: true });
})();
